import React from "react";
import { getCitiesData, getProvincesData } from "api/BranchAPI";
import { ICity, IProvince } from "views/admin/branches/types/branch.interface";

const useLocationArea = () => {
  const [provinces, setProvinces] = React.useState<IProvince[]>([]);
  const [cities, setCities] = React.useState<ICity[]>([]);
  const [selectedProvince, setSelectedProvince] = React.useState<IProvince>();
  const [selectedCity, setSelectedCity] = React.useState<ICity>();

  const getProvinces = async () => {
    const response = await getProvincesData();
    setProvinces(response.data);
  };

  const getSelectedProvince = async (provinceId: number) => {
    const res = await getProvincesData();
    const provincesData = res.data.data;
    const final = provincesData.find(
      (province: IProvince) => province.id === provinceId
    );

    setSelectedProvince(final);

    return {
      value: provinceId,
      label: final.province,
    };
  };

  const getCities = async (provinceId: number) => {
    const response = await getCitiesData(provinceId);
    setCities(response.data);
  };

  const getSelectedCity = async (cityId: number, provinceId: number) => {
    const res = await getCitiesData(provinceId);
    const citiesData = res.data.data;
    const final = citiesData.find((city: ICity) => city.id === cityId);

    setSelectedCity(final);

    return {
      value: cityId,
      label: final.city_name,
    };
  };

  const loadAsyncProvinces = async () => {
    const res = await getProvincesData();
    const resJSON = [
      ...res.data.data.map((item: IProvince) => ({
        ...item,
        value: item.id,
        label: item.province,
      })),
    ];

    return {
      options: resJSON,
      hasMore: false,
      additional: {
        page: 1,
      },
    };
  };

  const loadAsyncCities = async (provinceId: number) => {
    const res = await getCitiesData(provinceId);
    const resJSON = [
      ...res.data.data.map((item: ICity) => ({
        ...item,
        value: item.id,
        label: item.city_name,
      })),
    ];

    return {
      options: resJSON,
      hasMore: resJSON.length >= 100,
      additional: {
        page: 1,
      },
    };
  };

  const handleOnProvinceChange = (value: IProvince) => {
    setSelectedProvince(value);
  };

  const handleOnCityChange = (value: ICity) => {
    setSelectedCity(value);
  };

  return {
    provinces,
    cities,
    selectedProvince,
    selectedCity,
    getProvinces,
    getSelectedProvince,
    getCities,
    getSelectedCity,
    loadAsyncProvinces,
    loadAsyncCities,
    handleOnProvinceChange,
    handleOnCityChange,
  };
};

export default useLocationArea;
